import { Colors } from '~/themes/colors';
import { IIconProps } from './Types';

export const CloseCircleOutlineIcon = ({ color = Colors.secondary_500, size = 24 }: IIconProps) => (
  <svg fill="none" height={size} viewBox="0 0 25 24" width={size}>
    <path
      d="M10.0769 14L12.0921 12M12.0921 12L14.1074 10M12.0921 12L10.0769 10M12.0921 12L14.1074 14M21.1608 12C21.1608 16.9706 17.1006 21 12.0921 21C7.08363 21 3.02344 16.9706 3.02344 12C3.02344 7.02944 7.08363 3 12.0921 3C17.1006 3 21.1608 7.02944 21.1608 12Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
